import React from 'react';
import SimpleForm from './SimpleForm';
import Calculations from './Calculations';
import Comparison from './Comparison';
import getAllSchemaFieldsName from './utility/getAllSchemaFieldsName';
import filterFormikValues from './utility/filterFormikValues';
import { GENERICFORMTYPES } from '../../schemas/stepMap';

export default function FormBuilder({
  formSchema,
  formType,
  data,
  beforeData = {},
  afterData = null,
  docId,
  calculationsSchema,
  setSubmitted,
  keyMetricsSchema,
  keyMetricsData,
  embedVersion = false,
  onFormSubmitted = () => {},
  onReportClick = () => {},
}) {
  switch (formType) {
    case GENERICFORMTYPES.simpleForm:
      return (
        <SimpleForm
          formSchema={formSchema}
          data={data}
          beforeData={beforeData}
          docId={docId}
          setSubmitted={setSubmitted}
          embedVersion={embedVersion}
          onFormSubmitted={onFormSubmitted}
        />
      );
    case GENERICFORMTYPES.calculations:
      return (
        <Calculations
          onReportClick={onReportClick}
          calculationsSchema={calculationsSchema}
          beforeData={beforeData}
          afterData={afterData}
          keyMetricsSchema={keyMetricsSchema}
          keyMetricsData={keyMetricsData}
        />
      );
    case GENERICFORMTYPES.comparison:
      return (
        <Comparison
          formSchema={formSchema}
          beforeData={beforeData}
          afterData={afterData}
        />
      );
    default:
      return null;
  }
}

export { SimpleForm, getAllSchemaFieldsName, filterFormikValues };
